<div class="card cardMeasurements" data-testid="order-position-card" [attr.data-status]="orderPosition().status">
  <div class="card-body">
    <div class="row mb-2">
      <div class="productImage col-sm-3">
        @if (orderPosition().files[0]?.imageUrls?.length > 0) {
          <img [src]="orderPosition().files[0].imageUrls[0].mediumImageUrl" class="img-fluid" alt="" />
        }
      </div>
      <div class="col-sm-6">
        <h5 class="card-title mb-1 d-block NameLabel">
          {{ orderPosition().skuName1 }}
        </h5>
        <h5 class="d-block" i18n>Anzahl: {{ orderPosition().quantity }}</h5>
        <p class="orderPositionDescription" [title]="orderPosition().skuDescription">
          {{ orderPosition().skuDescription }}
        </p>
      </div>
      <div class="col-sm-3">
        @if (isBought) {
          @if (claimable()) {
            <div class="form-check">
              <input
                #claimBox
                class="form-check-input"
                type="checkbox"
                [id]="checkboxId"
                [checked]="selected()"
                (change)="selected.set(claimBox.checked)"
                data-testid="order-position-claim-checkbox"
                />
              <label class="form-check-label" [attr.for]="checkboxId" i18n>Stornieren</label>
            </div>
          }
        } @else {
          <!-- Requested or done; a status this build does not know names nothing. -->
          @let statusName = orderPosition().status | orderPositionStatusDisplayName;
          @if (statusName) {
            <span class="badge bg-secondary" data-testid="order-position-status-label">{{ statusName }}</span>
          }
        }
      </div>
    </div>
  </div>
</div>
